import ApplicationController from './application_controller'
import { get_csrf_token } from '../app/csrf_token.js'

export default class extends ApplicationController {

	static targets = [ 'modelAttribute' ]

	static values = {
		editPath: String,
		modelTarget: String,
	}

	connect() {
		if (this.hasTargetValue) {
			this.modelTargetId = this.targetValue
		} else {
			this.modelTargetId = this.element.id
		}
	}

	edit(_event) {
		fetch(this.editPathValue, {
			method: 'POST',
			body: this.getFormData()
		})
		.then(r => r.text())
		.then(html => Turbo.renderStreamMessage(html))
	}

	getFormData() {
		const formData = new FormData()
		formData.append('authenticity_token', get_csrf_token())
		formData.append('target', this.modelTargetId)

		for (const modelAttribute of this.modelAttributeTargets) {
			formData.append(modelAttribute.dataset.attributeName, modelAttribute.value)
		}

		return formData
	}
}
